
// CAPACITACION_TYPES
export const PLANIFICADA_ID = 1;
export const REFORZAMIENTO_ID = 2;

// CAPACTACION_ROLES
export const ROL_ADMINISTRADOR = '1';
export const ROL_EMPRESA = '2';
export const ROL_CONTRATISTA = '3';

// CAPACITACION_STATES
export const ABIERTA_STATE = 1;
export const ENVIADA_APROBACION_STATE = 2;
export const APROBADA_STATE = 3;
export const RECHAZADA_STATE = 4;
export const CERRADA_STATE = 5;
export const PENDIENTE_STATE = 6;
export const CANCELADA_STATE = 8;
export const CERRADA_CON_RETRASO_STATE = 7;
export const PENDIENTE_CON_RETRASO_STATE = 9;


// CAPACITACION_EJECUTORES
export const EJECUTOR_OTHERS_ID = 4;

// OTHERS
export const MONTHS = [
  { id: 1, label: 'Enero' },
  { id: 2, label: 'Febrero' },
  { id: 3, label: 'Marzo' },
  { id: 4, label: 'Abril' },
  { id: 5, label: 'Mayo' },
  { id: 6, label: 'Junio' },
  { id: 7, label: 'Julio' },
  { id: 8, label: 'Agosto' },
  { id: 9, label: 'Septiembre' },
  { id: 10, label: 'Octubre' },
  { id: 11, label: 'Noviembre' },
  { id: 12, label: 'Diciembre' }
];

export const MONTHS_BD = [
  { id: '01', label: 'Enero' },
  { id: '02', label: 'Febrero' },
  { id: '03', label: 'Marzo' },
  { id: '04', label: 'Abril' },
  { id: '05', label: 'Mayo' },
  { id: '06', label: 'Junio' },
  { id: '07', label: 'Julio' },
  { id: '08', label: 'Agosto' },
  { id: '09', label: 'Septiembre' },
  { id: '10', label: 'Octubre' },
  { id: '11', label: 'Noviembre' },
  { id: '12', label: 'Diciembre' }
];

export const ROL = [
  { id: 1, label: 'Administrador' },
  { id: 2, label: 'Empresa' },
  { id: 3, label: 'Contratista' },
  { id: 4, label: 'Desarrollador' }
];
export const ESPECIALES = [
  { id: 1, label: ' ' },
  { id: 2, label: '!' },
  { id: 3, label: '#' },
  { id: 4, label: '$' },
  { id: 5, label: '%' },
  { id: 6, label: '&' },
  { id: 7, label: '/' },
  { id: 8, label: '(' },
  { id: 9, label: ')' },
  { id: 10, label: '=' },
  { id: 11, label: '?' },
  { id: 12, label: '¡' },
  { id: 13, label: '°' },
  { id: 14, label: '¨' },
  { id: 15, label: '*' },
  { id: 16, label: '[' },
  { id: 17, label: ']' },
  { id: 18, label: ';' },
  { id: 19, label: ':' },
  { id: 20, label: '|' },
  { id: 21, label: '¬' },
  { id: 22, label: '"' },
  { id: 23, label: '€' },
  { id: 24, label: '�' },
  { id: 25, label: ',' },
  { id: 26, label: '„' },
  { id: 27, label: '•' },
  { id: 28, label: '{' },
  { id: 29, label: '}' },
  { id: 30, label: '´' },
  { id: 31, label: '+' },
  { id: 32, label: 'ü' },
  { id: 33, label: 'á' },
  { id: 34, label: 'é' },
  { id: 35, label: 'í' },
  { id: 36, label: 'ó' },
  { id: 37, label: 'ú' },
  { id: 38, label: 'Á' },
  { id: 39, label: 'É' },
  { id: 40, label: 'Í' },
  { id: 41, label: 'Ó' },
  { id: 42, label: 'Ú' },
  { id: 43, label: 'Ä' },
  { id: 44, label: 'Ë' },
  { id: 45, label: 'Ï' },
  { id: 46, label: 'Ö' },
  { id: 47, label: 'Ü' },
  { id: 48, label: 'ä' },
  { id: 49, label: 'ë' },
  { id: 50, label: 'ï' },
  { id: 51, label: 'ö' },
  { id: 52, label: '>' },
  { id: 53, label: '<' },
  // tslint:disable-next-line: quotemark
  { id: 54, label: '\\' },
  { id: 55, label: '..' },
  { id: 56, label: '@@' },
];

export const DELIMITADOR_ = 'MzA='
export const DELIMITADO__ = 'NDY='

export const CANTIDAD_MINIMA = 12;